import { buildProps } from '@element-plus/utils'

import type { ExtractPropTypes } from 'vue'

export const tableV3Props = buildProps({})

export type TableV3Props = ExtractPropTypes<typeof tableV3Props>
